/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable react/jsx-no-undef */
/* eslint-disable no-undef */
import React from 'react';
import {
  Container,
  Details,
  Title,
  Text,
  ImageWrapper,
  Button
} from './styles';

const EndorsementNews = () => {
  function downloadFile() {
    const URL =
      'https://static.juntoseguros.com/docs/Manual_risco_andamento.pdf';
    window.open(URL);
  }
  return (
    <Container data-testid="endorsement-news">
      <Details>
        <Title>
          <Text>Novidade</Text>
          Descomplicamos a emissão de riscos em andamento!
        </Title>
        <Button
          id="button"
          target="_blank"
          value="Confira"
          type="button"
          onClick={() => downloadFile()}
        >
          Confira
        </Button>
      </Details>
      <ImageWrapper>
        <img
          src="https://static.juntoseguros.com/images/img_mulher.svg"
          alt="Mulher sorrindo olhando para esquerda"
        />
      </ImageWrapper>
    </Container>
  );
};

export default EndorsementNews;
